import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { environment } from "../../../../Environments/Environment";
import { VendorSearchRequest } from "../Dto/VendorSearchRequest";
import { VendorSearchResponse } from "../Dto/VendorSearchResponse";
import { CreateVendorRequest } from "../Dto/CreateVendorRequest";
import { Vendor } from "../Dto/VendorModel";

@Injectable({ providedIn: "root" })
export class VendorApi {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.adminServiceUrl;

  async searchVendors(params: VendorSearchRequest): Promise<VendorSearchResponse> {
    const url = new URL("vendors", `${this.baseUrl}/`);
    const searchParams = new URLSearchParams();

    if (params.search) searchParams.set("search", params.search);
    if (params.name) searchParams.set("name", params.name);
    if (params.type) searchParams.set("type", params.type);
    if (params.contactPerson) searchParams.set("contactPerson", params.contactPerson);
    if (params.email) searchParams.set("email", params.email);
    if (params.stateProvinceRegion) searchParams.set("stateProvinceRegion", params.stateProvinceRegion);
    if (params.countyDistrict) searchParams.set("countyDistrict", params.countyDistrict);
    if (params.subdistrictMunicipality) searchParams.set("subdistrictMunicipality", params.subdistrictMunicipality);
    if (params.communeVillage) searchParams.set("communeVillage", params.communeVillage);
    if (params.line) searchParams.set("line", params.line);
    if (params.zip) searchParams.set("zip", params.zip);
    if (params.code) searchParams.set("code", params.code);
    if (params.page !== undefined) searchParams.set("page", params.page.toString());
    if (params.limit !== undefined) searchParams.set("limit", params.limit.toString());
    if (params.createdAtFrom) searchParams.set("createdAtFrom", params.createdAtFrom);
    if (params.createdAtTo) searchParams.set("createdAtTo", params.createdAtTo);

    if (searchParams.toString()) {
      url.search = searchParams.toString();
    }

    return await firstValueFrom(this.http.get<VendorSearchResponse>(url.toString(), { withCredentials: true }));
  }

  async createVendor(payload: CreateVendorRequest): Promise<Vendor> {
    const url = new URL("vendors", `${this.baseUrl}/`);
    return await firstValueFrom(this.http.post<Vendor>(url.toString(), payload, { withCredentials: true }));
  }

  async updateVendor(id: string, payload: CreateVendorRequest): Promise<Vendor> {
    const url = new URL(`vendors/${id}`, `${this.baseUrl}/`);
    return await firstValueFrom(this.http.put<Vendor>(url.toString(), payload, { withCredentials: true }));
  }

  async getVendorById(id: string): Promise<Vendor | null> {
    const url = new URL(`vendors/${id}`, `${this.baseUrl}/`);
    return await firstValueFrom(this.http.get<Vendor>(url.toString(), { withCredentials: true }));
  }

  async deleteVendor(id: string): Promise<void> {
    const url = new URL(`vendors/${id}`, `${this.baseUrl}/`);
    await firstValueFrom(this.http.delete<void>(url.toString(), { withCredentials: true }));
  }
}
